<template>
  <v-row
    align="center"
    justify="center"
    class="info-line"
  >
    <v-col
      cols="12"
      :lg="widthCols"
      class="py-0"
    >
      <v-row>
        <v-col cols="4">
          <span class="label">
            {{ label }}
          </span>
        </v-col>
        <v-col cols="8">
          <span
            v-if="file"
            class="value"
          >
            <a
              target="_blank"
              :href="file.url"
            >
              {{ file.fileName }}
            </a>{{ `(${fileSize})` }}
          </span>

          <span v-else-if="icon">
            <v-icon>{{ icon }}</v-icon>
          </span>

          <span
            v-else
            class="value"
          >
            {{ value }}

            <slot name="value" />
          </span>
        </v-col>
      </v-row>
      <v-divider />
    </v-col>
  </v-row>
</template>

<script>
import prettyBytes from 'pretty-bytes';
import { mapGetters } from 'vuex';

export default {
    props: {
        file: {
            type: Object,
            default: null,
        },
        label: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            default: null,
        },
        value: {
            type: String,
            default: '',
        },
        widthCols: {
            type: Number,
            default: 8,
        },
    },
    computed: {
        ...mapGetters([
            'lang',
        ]),
        fileSize() {
            return prettyBytes(this.file.size, { locale: this.lang });
        },
    },
};
</script>
